
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/senior-living-pricing-trends",
      function () {
        return require("private-next-pages/senior-living-pricing-trends.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/senior-living-pricing-trends"])
      });
    }
  